<template>
  <div >    
    <Header />
    <div class="title">
      <div>
        <span class="navTitle">Expositions</span>
      </div>
      
    </div>
    <div class="action-buttons">
      <q-btn class="ma-2" tile color="teal" dark @click="navigate">Ajouter une exposition</q-btn>
      <q-btn v-if="isAdmin" class="ma-2" :style="{ backgroundColor: '#8257d4' }"  color=#8257d4 icon="archive" @click="goToArchives">
        Voir les archives
      </q-btn>
    </div>
      <hr style="margin-bottom: 15px;">
      <ExposList :id="this.id" />
  </div>
</template>

<script>
import ExposList from "../components/ExposList.vue";
import {useStore} from "vuex";
import Header from "../components/Header.vue";

export default {
  components:{
      ExposList,
      Header
  },
  data(){
    return({
      id: null,
      exhibits: [],
      isAdmin: false
    })
  },
  methods:{
    navigate(){
      this.$router.push({name: 'AdminAdd', params: {'id': this.id}} )
    },
    goToArchives() {
      this.$router.push({ name: 'Archives' });
    }
  },
  created(){
    const store = useStore()
    console.log("created");
    this.id = store.state.userId
    console.log(this.id)
    console.log(store.state.adminIds)
    console.log(store.state.adminIds.includes(this.id))
    this.isAdmin = store.state.adminIds.includes(this.id)
  }
}
</script>

<style>
  body{
    background-color: white;
  }
  h1{
    margin-left: 5%;
    margin-bottom: 30px; 
    margin-top: 30px;
  }
  .action-buttons {
    margin-left: 7%;
    margin-bottom: 15px;
    display: flex;
    gap: 1rem;
  }
  .navTitle{
    font-size: 1.2rem;
    margin-left:1%;
    cursor: pointer;
  }
</style>